import type { ProfileView } from '@muzly/api-client';

import type { OnboardingAnswer } from '../onboarding/flow';

/**
 * 서버 프로필 뷰 → 온보딩 답 맵. `toProfileBody` 의 반대 방향이고, 쓰는 자리는 하나다:
 * 로컬에 프로필이 없을 때의 **부팅 복원**(앱 재설치·기기 이전).
 *
 * `id`·`lang` 은 설문 답이 아니라 담지 않는다 — `lang` 은 i18n 상태가 정본이고
 * 복원 시 `changeLanguage` 로 따로 적용된다. 서버가 아직 안 채운 필드는 `''`(LUT 의
 * initial)로 오는데, 그건 답이 아니라 빈칸이라 역시 담지 않는다.
 */
const ANSWER_KEYS = [
  'nick',
  'gender',
  'experience',
  'style',
  'purpose',
  'environment',
  'condition',
] as const;

export const fromProfileView = (
  view: ProfileView,
): Record<string, OnboardingAnswer> => {
  const answers: Record<string, OnboardingAnswer> = {};

  for (const key of ANSWER_KEYS) {
    const value = view[key];
    if (typeof value === 'string' && value.length > 0) {
      answers[key] = value;
    }
  }
  // 설문은 연도를 문자열로 고른다(`year` kind) — 계약의 number 를 되돌려 놓는다.
  if (typeof view.birthYear === 'number' && Number.isFinite(view.birthYear)) {
    answers.birthYear = String(view.birthYear);
  }

  return answers;
};
